import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, createRef } from 'react';
import { Links, Select, HiddenList } from './styles';
import { jsxs as _jsxs } from "react/jsx-runtime";

var ResponsiveMenu = /*#__PURE__*/function (_Component) {
  _inherits(ResponsiveMenu, _Component);

  var _super = _createSuper(ResponsiveMenu);

  function ResponsiveMenu() {
    var _this;

    _classCallCheck(this, ResponsiveMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.listRef = /*#__PURE__*/createRef();
    _this.visibleItemsRefs = new Map();
    _this.hiddenItemsRefs = new Map();
    _this.moreLink = /*#__PURE__*/createRef();
    _this.isMobile = false;
    _this.state = {
      items: [],
      cachedItems: null,
      visibleItems: [],
      hiddenItems: [],
      hiddenItemsDimensions: [],
      isOpen: false
    };

    _this.componentDidUpdate = function () {
      _this.updateVisibleLinksItems();
    };

    _this.updateVisibleLinksItems = function () {
      var _this$state = _this.state,
          hiddenItemsDimensions = _this$state.hiddenItemsDimensions,
          hiddenItems = _this$state.hiddenItems;
      var containerWidth = _this.props.containerWidth;

      if (containerWidth && document.body.clientWidth > 640) {
        var needHideLink = containerWidth && containerWidth <= _this.listRef.current.clientWidth;
        var needShowLink = containerWidth && !!hiddenItems.length && containerWidth > _this.listRef.current.clientWidth + (hiddenItemsDimensions[hiddenItemsDimensions.length - 1] || 0);

        if (needHideLink) {
          _this.putLinkToHidden();
        }

        if (needShowLink) {
          _this.getLinkFromHidden();
        }
      }
    };

    _this.putLinkToHidden = function () {
      if (_this.visibleItemsRefs.size > 0) {
        var lastDeletedLinkWidth = Array.from(_this.visibleItemsRefs)[_this.visibleItemsRefs.size - 1][1].current.clientWidth;

        _this.setState(function (_ref) {
          var visibleItems = _ref.visibleItems,
              hiddenItems = _ref.hiddenItems,
              hiddenItemsDimensions = _ref.hiddenItemsDimensions;
          return {
            visibleItems: visibleItems.slice(0, -1),
            hiddenItems: [visibleItems[visibleItems.length - 1]].concat(_toConsumableArray(hiddenItems)),
            hiddenItemsDimensions: [].concat(_toConsumableArray(hiddenItemsDimensions), [lastDeletedLinkWidth])
          };
        });
      }
    };

    _this.getLinkFromHidden = function () {
      _this.setState(function (_ref2) {
        var visibleItems = _ref2.visibleItems,
            hiddenItems = _ref2.hiddenItems,
            hiddenItemsDimensions = _ref2.hiddenItemsDimensions;
        return {
          visibleItems: [].concat(_toConsumableArray(visibleItems), [hiddenItems[0]]),
          hiddenItems: hiddenItems.slice(1),
          hiddenItemsDimensions: hiddenItemsDimensions.slice(0, -1)
        };
      });
    };

    _this.toggle = function (open) {
      _this.setState(function (prevState) {
        return {
          isOpen: open !== undefined ? open : !prevState.isOpen
        };
      });
    };

    _this.touchToggle = function (e) {
      if (e.currentTarget === _this.moreLink.current) {
        _this.toggle();
      }
    };

    return _this;
  }

  _createClass(ResponsiveMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateVisibleLinksItems();
      window.addEventListener('touchend', this.touchToggle);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('touchend', this.touchToggle);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          isOpen = _this$state2.isOpen,
          visibleItems = _this$state2.visibleItems,
          hiddenItems = _this$state2.hiddenItems;
      var _this$props = this.props,
          getActiveLink = _this$props.getActiveLink,
          renderLink = _this$props.renderLink,
          renderHiddenLink = _this$props.renderHiddenLink,
          renderMoreBtn = _this$props.renderMoreBtn;
      this.isMobile = false;
      var activeLink = getActiveLink(this.props, this.state);
      this.visibleItemsRefs = new Map();
      this.hiddenItemsRefs = new Map();
      var commonProps = {
        state: this.state,
        props: this.props,
        active: activeLink
      };
      return /*#__PURE__*/_jsxs(Links, {
        ref: this.listRef,
        children: [visibleItems.map(function (item, index) {
          var ref = /*#__PURE__*/createRef();

          _this2.visibleItemsRefs.set(index, ref);

          return renderLink(_objectSpread(_objectSpread({}, commonProps), {}, {
            item: item,
            ref: ref,
            index: index
          }));
        }), hiddenItems.length > 0 && /*#__PURE__*/_jsx(Select, {
          onMouseEnter: function onMouseEnter() {
            return _this2.toggle(true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this2.toggle(false);
          },
          open: isOpen
        }, void 0, renderMoreBtn(_objectSpread(_objectSpread({}, commonProps), {}, {
          ref: this.moreLink,
          toggle: this.touchToggle
        })), /*#__PURE__*/_jsx(HiddenList, {
          isOpen: isOpen
        }, void 0, hiddenItems.map(function (item, index) {
          var ref = /*#__PURE__*/createRef();

          _this2.hiddenItemsRefs.set(index, ref);

          return renderHiddenLink(_objectSpread(_objectSpread({}, commonProps), {}, {
            item: item,
            ref: ref,
            index: index
          }));
        })))]
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.items !== prevState.cachedItems) {
        var itemsArray = Array.isArray(nextProps.items) ? nextProps.items : Object.values(nextProps.items);
        return {
          items: itemsArray,
          cachedItems: nextProps.items,
          visibleItems: itemsArray.slice(0, nextProps.defaultItemsCount),
          hiddenItems: itemsArray.slice(nextProps.defaultItemsCount, Math.max(itemsArray.length, nextProps.defaultItemsCount))
        };
      }

      return null;
    }
  }]);

  return ResponsiveMenu;
}(Component);

ResponsiveMenu.defaultProps = {
  containerWidth: null,
  getActiveLink: function getActiveLink() {},
  defaultItemsCount: 2
};
export default ResponsiveMenu;